// extracted by mini-css-extract-plugin
export default {"container":"school-features_container__wKhFi","features_heading":"school-features_features_heading__HwPQo"};